import { render, staticRenderFns } from "./OperationsByCustomer.vue?vue&type=template&id=253db041"
import script from "./OperationsByCustomer.vue?vue&type=script&lang=js"
export * from "./OperationsByCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports